import { render, staticRenderFns } from "./ChoiceGroupEdit.vue?vue&type=template&id=dba8c508&scoped=true"
import script from "./ChoiceGroupEdit.vue?vue&type=script&lang=js"
export * from "./ChoiceGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ChoiceGroupEdit.vue?vue&type=style&index=0&id=dba8c508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba8c508",
  null
  
)

export default component.exports